__turbopack_context__.v({
  "bannerText": "styleConstants-module__fOOyla__bannerText",
  "body1": "styleConstants-module__fOOyla__body1",
  "body2": "styleConstants-module__fOOyla__body2",
  "heading": "styleConstants-module__fOOyla__heading",
  "linkButton": "styleConstants-module__fOOyla__linkButton",
  "sectionPadding": "styleConstants-module__fOOyla__sectionPadding",
  "subHeading1": "styleConstants-module__fOOyla__subHeading1",
  "subHeading2": "styleConstants-module__fOOyla__subHeading2",
});
